__turbopack_context__.v({
  "bar": "oQjeqa_bar",
  "container": "oQjeqa_container",
});
